import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';

import { useToast } from 'Store/toast';
import getGenerateSchedule from 'Api/schedule-generate/getGenerateSchedule';

import { useScheduleGenerateState } from 'View/schedule-generate/state';

import getGenerateScheduleRequest from './model/request/getGenerateScheduleRequest';
import getGenerateScheduleResponse from './model/response/getGenerateScheduleResponse';

const useGetGenerateSchedule = () => {
  const { t } = useTranslation('schedule-generate');
  const { updateState, hostsInRulesets } = useScheduleGenerateState();
  const { onOpenToast } = useToast();
  return useMutation({
    mutationFn: async (data) => {
      updateState({ formData: data });
      const payload = getGenerateScheduleRequest(data);

      const response = await getGenerateSchedule(payload);

      const result = getGenerateScheduleResponse(response, hostsInRulesets, data);

      return result;
    },
    onMutate: () => {
      updateState({ viewState: 'loading' });
    },
    onSuccess: (result) => {
      setTimeout(() => {
        updateState({
          viewState: 'generate-result',
          generateResultData: result,
          selectedTab: result?.accounts[0].type,
          accounts: cloneDeep(result?.accounts),
        });
      }, 500);
    },
    onError: () => {
      setTimeout(() => {
        onOpenToast({
          status: 'error',
          title: t('failedGenerateTitle'),
          description: t('failedGenerateDesc'),
          duration: 3,
          alwaysShow: false,
        });
        updateState({ viewState: 'form' });
      }, 500);
    },
  });
};

export default useGetGenerateSchedule;
